import customFetchApi from './customFetchApi'
import env from '~config/envConfig'

import {
  Configuration,
  UserApi as UserApiClass,
  CourseApi as CourseApiClass,
  SpareAxleRequestApi as SpareAxleRequestApiClass,
} from '@saf/saf-kundenportal-frontend-api'

const openApiConfiguration = new Configuration({
  basePath: env.basePath,
  fetchApi: customFetchApi(fetch),
})

export const UserApi = new UserApiClass(openApiConfiguration)
export const CourseApi = new CourseApiClass(openApiConfiguration)
export const SpareAxleRequestApi = new SpareAxleRequestApiClass(openApiConfiguration)
